const GUEST_PARTNER_STORAGE_KEY = "guestPartnerSlug";

export const GUEST_PARTNER_ROUTES = {
  "the-top-villas": {
    shopBasePath: "/the-top-villas",
    hostId: "6655d09b2c10e2ce365d5a8b",
    // Resolved from Host.firstName + Host.lastName (6655d09b2c10e2ce365d5a8b)
    propertyManager: "Katie Plummer",
  },
  avantstay: {
    shopBasePath: "/avantstay",
    hostId: "6aa2f8e3ab27fa739e44ae7c",
    logoUrl: "https://bellhopt-public.s3.us-west-1.amazonaws.com/Avantstay-Logo.png",
    propertyManager: "AvantStay",
  },
};

export const detectGuestPartner = (pathname = "") => {
  for (const [slug, config] of Object.entries(GUEST_PARTNER_ROUTES)) {
    const base = config.shopBasePath;
    if (pathname === base || pathname.startsWith(`${base}/`)) {
      return { slug, ...config };
    }
  }
  return null;
};

export const getStoredGuestPartner = () => {
  try {
    const slug = localStorage.getItem(GUEST_PARTNER_STORAGE_KEY);
    if (!slug || !GUEST_PARTNER_ROUTES[slug]) return null;
    return { slug, ...GUEST_PARTNER_ROUTES[slug] };
  } catch {
    return null;
  }
};

export const setStoredGuestPartner = (slug) => {
  try {
    if (slug && GUEST_PARTNER_ROUTES[slug]) {
      localStorage.setItem(GUEST_PARTNER_STORAGE_KEY, slug);
    } else {
      localStorage.removeItem(GUEST_PARTNER_STORAGE_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

export const getGuestShopHomePath = () => {
  return getStoredGuestPartner()?.shopBasePath || "/guest";
};
